const initialState = {
  Searchdata: [], 
 
  

};

const COLoginreducers = (state = initialState, action: any) => {
  switch (action.type) {
      case 'FETCH_EMAIL_SUCCESS':
          return {... state, approved:action.payload};
          
    default:
      return state;
  }
};

export default COLoginreducers;

